import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Checkbox, Tooltip } from '@codex/basics';
import styled from 'styled-components';
import {
  addProductAndTriggerAnalytics,
  removeProductAndTriggerAnalytics,
  showProductsComparision
} from '../../reduck/listingPageComparison.reduck';
import { getActiveListingPage } from '../../reduck/selectors';
import { getCompareCheckboxTranslation } from '../../translations/translations';


const DivWrapper = styled.div`
.resultList & {
  .compare-checkbox {
    margin-top: 20px;
  }

  .compare-checkbox-tooltip {
    position: relative;
    bottom: 95px;
    height: 0;
  }

  [data-component="compare-checkbox"] {
    position: relative;
  }
}

.resultGrid & {
  @media (min-width: 1024px) and (max-width: 1242px) {
    [class|="Checkbox__Container"] {
      font-size: 11px;
    }
    [class|="Checkbox__Box"] {
      margin-left: 0;
    }
  }

  .compare-checkbox-tooltip {
    z-index: 2;
    left: 12px;
    bottom: -63px;
    @media (min-width: 1024px) and (max-width: 1242px) {
      width: 180px;
      left: 0 !important;
      [class|="Tooltip"]:before {
        left: 17px;
      }
    }
  }
}
 
.checked {
  [class|="Checkbox__Box"] {
    border-color: #4e8130;
  }

  [class|="Checkbox__Label"] {
    text-decoration: underline;
  }
}
`;

const DivButton = styled.div`
  background-color: #f5f7fd;
  color: #404d94;
  font-size: 12px;
  font-weight: normal;
  border: solid 1px;
  border-radius: 4px;

  &.disabled {
    background-color: #f2f2f2;
    border-color: #999;
  }

  @media ${(p) => p.theme.breakpoints.mobile} {
    display: none;
  }

  @media ${(p) => p.theme.breakpoints.mobileLayoutLandscape} {
    display: none;
  }

  .dc-icon {
    width: 16px !important;
  }

  [class|="Checkbox__Container"] {
    padding: 5px;
  }

  [class|="Checkbox__Box"] {
    border-color: #CCC;
    margin-right: 5px;
    margin-left: 20px;
    width: 20px;
    height: 20px;
  }
`;

const DivCompareCheckboxTooltip = styled.div`
  position: absolute;
  width: 208px;

  [class|="Tooltip"]:before {
    left: 25px;
  }
`;

class CompareCheckbox extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false
    };
  }

  render() {
    const { checked, disabled, checkboxLabel, tooltipText, showComparision, checkCheckbox, unCheckCheckbox, productId,
      isPossibleToShowComparision } =
      this.props;
    const classList =
      `compare-checkbox${checked ? ' checked' : ''}${disabled ? ' disabled' : ''}`;

    return (
      <DivWrapper className={'checkboxWrapper'}>
        <DivButton
          className={classList}
          onClick={(e) => {
            e.preventDefault();
            if (disabled) {
              // show Tooltip if checkbox is disabled
              this.setState({ showTooltip: true }, () =>
                setTimeout(() => {
                  this.setState({ showTooltip: false });
                }, 3000));

            }

            // if checkbox is checked and user clicks on link, compared products are shown
            if (isPossibleToShowComparision && checked &&
              e.target.matches('.checked [class|="Checkbox__Label"]')) {
              showComparision();

              return;
            }

            if (checked) {
              unCheckCheckbox(productId);
            } else {
              checkCheckbox(productId);
            }
          }}
        >
          <Checkbox
            size={'extra-small'}
            disabled={disabled}
            checked={checked}
          >
            {checkboxLabel}
          </Checkbox>
        </DivButton>
        <DivCompareCheckboxTooltip className={'compare-checkbox-tooltip'}>
          {this.state.showTooltip
            ? (
              <Tooltip
                arrow={this.props.tooltipArrowDirection}
                textAlign={'center'}
                compact
              >
                {tooltipText}
              </Tooltip>
            ) : <noscript />}
        </DivCompareCheckboxTooltip>
      </DivWrapper>
    );
  }
}

CompareCheckbox.propTypes = {
  productId: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  isPossibleToShowComparision: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  checkCheckbox: PropTypes.func.isRequired,
  unCheckCheckbox: PropTypes.func.isRequired,
  showComparision: PropTypes.func.isRequired,
  checkboxLabel: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  tooltipArrowDirection: PropTypes.oneOf([
    'top',
    'right',
    'bottom',
    'left'
  ])
};

CompareCheckbox.defaultProps = {
  tooltipArrowDirection: 'top'
};

function mapStateToProps(state, ownProps) {
  const currentSegmentId = Number(getActiveListingPage(state).pageAttributes.filterAttributes.segment_id[0]);
  const checkedProducts = state.listingPage.comparison.products[currentSegmentId] || [];
  const isCheckboxChecked =
    checkedProducts.findIndex((checkedProduct) => checkedProduct.id === ownProps.productId) !== -1;

  return {
    checked: isCheckboxChecked,
    disabled: !isCheckboxChecked && checkedProducts.length >= 4,
    isPossibleToShowComparision: checkedProducts.length > 1,
    checkboxLabel: isCheckboxChecked && checkedProducts.length > 1
      ? `${getCompareCheckboxTranslation().checkboxLabel} (${checkedProducts.length} of 4)` // TODO add 'of 4' to translations
      : getCompareCheckboxTranslation().defaultLabel,
    tooltipText: getCompareCheckboxTranslation().tooltipText
  };
}

function mapDispatchToProps(dispatch) {
  return {
    checkCheckbox: (productId) => {
      dispatch(addProductAndTriggerAnalytics(productId));

    },
    unCheckCheckbox: (productId) => {
      dispatch(removeProductAndTriggerAnalytics(productId));
    },
    showComparision: () => {
      dispatch(showProductsComparision());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompareCheckbox);
